import { render, staticRenderFns } from "./AddSingleCompany.vue?vue&type=template&id=2ceac506"
import script from "./AddSingleCompany.vue?vue&type=script&lang=js"
export * from "./AddSingleCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports